import { render, staticRenderFns } from "./RequestURL.vue?vue&type=template&id=1a72d97f&scoped=true&"
import script from "./RequestURL.vue?vue&type=script&lang=js&"
export * from "./RequestURL.vue?vue&type=script&lang=js&"
import style0 from "./RequestURL.vue?vue&type=style&index=0&id=1a72d97f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72d97f",
  null
  
)

export default component.exports